<template>
	<Home>
		<template #header>
			<Header />
		</template>
	</Home>
</template>

<script setup lang="ts">
import Home from "@/rmo/content/Home.vue";
import Header from "@/rmo/components/Header.vue";
</script>
